import React from 'react';

function QrField({ value, maxLength }) {
  if (!value) return <>-</>;

  return (
    <img
      src={`${value}`}
      alt={value}
      style={{ width: '7vw', margin: '10px 0' }}
    />
  );
}

export default QrField;
